'use client';

import { useEffect, useRef, useState } from 'react';

/* Brief hero art at card size. The originals are ~3 MB PNGs (2400px); each
   has an 800px WebP sibling at `<key>.800.webp` (scripts/brief-hero-variants.py
   backfills them). A brief whose variant hasn't been generated yet 404s on the
   WebP, and this falls back to the original. */
export function BriefHeroImg({
  src,
  priority = false,
}: {
  src: string;
  priority?: boolean;
}) {
  const small = src.replace(/\.(png|jpe?g|webp)$/i, '.800.webp');
  const [url, setUrl] = useState(small === src ? src : small);
  const ref = useRef<HTMLImageElement>(null);
  // An error that fired before hydration never reaches onError — check once.
  useEffect(() => {
    const img = ref.current;
    if (img && img.complete && img.naturalWidth === 0 && img.currentSrc) {
      setUrl(src);
    }
  }, [src]);
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      ref={ref}
      src={url}
      alt=""
      loading={priority ? 'eager' : 'lazy'}
      fetchPriority={priority ? 'high' : undefined}
      decoding="async"
      onError={() => {
        if (url !== src) setUrl(src);
      }}
      style={{
        display: 'block',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      }}
    />
  );
}
